<!-- 项目应用 -->
<template>
    <div class="project-application">
        <!-- 标题区域 -->
        <div class="page-header">
            <h1 class="title">{{ $t('menu.project') }}</h1>
            <p class="subtitle">PROJECT APPLICATION</p>
        </div>

        <!-- 类型切换按钮组 -->
        <div class="type-buttons">
            <button v-for="item in projectApplicationChildren" :key="item.typeId"
                :class="['type-btn', { active: currentTypeId === item.typeId }]" @click="handleTypeChange(item.typeId)">
                {{ $t(item.typeName) }}
            </button>
        </div>

        <!-- 项目卡片列表 -->
        <div class="project-list" v-if="projectListFilter.length > 0">
            <div v-for="(item, index) in projectListFilter" :key="`${item.typeId}-${item.projectId}`">
                <div class="card">
                    <div class="card-image">
                        <img :src="item.imgURL" :alt="item.title">
                    </div>
                    <div class="card-content">
                        <h3>{{ item.title }}</h3>
                        <p>{{ item.desc }}</p>
                    </div>
                    <span class="more-link not-select"
                        @click="$router.push({ path: '/projectApplicationDetail', query: { typeId: item.typeId, projectId: item.projectId } })">{{$t('base.learnMore')}}</span>
                </div>
            </div>

        </div>

        <div v-else class="empty-wrapper">
            <a-empty description="暂无数据" :image="require('@/assets/portal/empty.png')" />
        </div>
    </div>
</template>

<script>
import { projectApplicationChildren, projectApplications, projectApplicationsEn } from '@/config/commonVar'


export default {
    name: 'ProjectApplication',

    data() {
        return {
            projectApplicationChildren,
            currentTypeId: null,
        }
    },
    computed: {
        // 根据当前类型ID获取对应的项目列表
        projectListFilter() {
            let projectList=this.$store.getters.lang === 'en' ? projectApplicationsEn : projectApplications
            return projectList.filter(item => item.typeId === this.currentTypeId)
        }
    },
    created() {
        // 从路由获取 typeId
        const { typeId } = this.$route.query
        this.currentTypeId = typeId ? Number(typeId) : this.projectApplicationChildren[0].typeId
    },

    watch: {
        "$route.query.typeId": function (newVal) {
            this.currentTypeId = Number(newVal)
        }
    },
    methods: {
        handleTypeChange(typeId) {
            this.$router.push({ query: { typeId } })
        }
    }
}
</script>

<style lang="less" scoped>
.project-application {
    max-width: @mainContainerWidth;
    margin: 0 auto;
    padding: 60px 0;

    .page-header {
        text-align: center;
        margin-bottom: 48px;

        .title {
            font-size: 32px;
            font-weight: 500;
            color: #fff;
            margin-bottom: 12px;
            line-height: 1;
        }

        .subtitle {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.6);
            text-transform: uppercase;
            letter-spacing: 1px;
        }
    }

    .type-buttons {
        display: flex;
        justify-content: center;
        gap: 40px;
        margin-bottom: 60px;

        .type-btn {
            padding: 10px 32px;
            border: none;
            border-radius: 24px;
            background: #282A2C;
            color: #fff;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.3s ease;
            font-weight: 500;

            &:hover {
                background: #464748c2;
            }

            &.active {
                background: #3366ff;
                // background: linear-gradient(270deg, #d9a8ff 0%, #0166fc 100%);
                color: #FFFFFF;
                box-shadow: 0 4px 16px rgba(49, 145, 255, 0.35);
            }
        }
    }

    .project-list {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 24px 12.66px;

        .card {
            flex: 1;
            // background: red;
            // background: linear-gradient(180deg, rgba(28, 106, 184, 0) 0%, rgba(69, 128, 255, 0.2) 100%), #0C0C0C;
            border-radius: 8px;
            overflow: hidden;
            cursor: pointer;
            transition: all 0.3s ease;
            position: relative;
            border: 2px solid #333;
            width: 424px;
            height: 438px;

            &:hover {
                border: 2px solid #333;

                .card-image {
                    top: -240px;
                }

                .card-content {
                    top: 0;
                    height: 100%;

                    >p {
                        -webkit-line-clamp: unset;
                    }
                }
            }

            .card-image {
                height: 240px;
                overflow: hidden;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                z-index: 2;
                transition: top 0.5s ease;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                &::after {
                    content: '';
                    position: absolute;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    height: 60%;
                    // background: linear-gradient(to bottom,
                    //         rgba(0, 0, 0, 0) 0%,
                    //         rgba(0, 0, 0, 0.8) 100%);
                    pointer-events: none;
                }
            }

            .card-content {
                padding: 32px 32px 60px;
                position: absolute;
                top: 240px;
                left: 0;
                right: 0;
                height: 212px;
                z-index: 1;
                // background: #1A1A1A;
                background: linear-gradient(180deg, rgba(28, 106, 184, 0) 0%, rgba(69, 128, 255, 0.2) 100%), #0C0C0C;

                transition: all 0.5s ease;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;

                h3 {
                    font-size: 20px;
                    color: #FFFFFF;
                    margin-bottom: 12px;
                    font-weight: 500;
                }

                p {
                    font-size: 14px;
                    color: rgba(255, 255, 255, 0.6);
                    line-height: 30px;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    overflow: auto;

                    &:hover {
                        // -webkit-line-clamp: unset;
                    }
                }

                .more-link {
                    position: absolute;
                    bottom: 32px;
                    left: 32px;
                    color: #FFFFFF;
                    font-size: 14px;
                    transition: all 0.3s ease;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    z-index: 3;

                    &::after {
                        content: '';
                        width: 16px;
                        height: 16px;
                        background: url('~@/assets/portal/arrow-right.png') no-repeat center;
                        background-size: contain;
                        transition: transform 0.3s ease;
                    }
                }
            }

            .more-link {
                position: absolute;
                bottom: 32px;
                left: 32px;
                color: #FFFFFF;
                font-size: 14px;
                transition: all 0.3s ease;
                display: flex;
                align-items: center;
                gap: 4px;
                z-index: 3;

                &::after {
                    content: '';
                    width: 16px;
                    height: 16px;
                    background: url('~@/assets/portal/arrow-right.png') no-repeat center;
                    background-size: contain;
                    transition: transform 0.3s ease;
                }
            }
        }

    }

    .empty-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 400px;

        /deep/ .ant-empty {
            .ant-empty-image {
                // height: 160px;

                img {
                    height: 100%;
                    user-select: none;
                    -webkit-user-drag: none;
                }
            }

            .ant-empty-description {
                color: rgba(255, 255, 255, 0.6) !important;
                font-size: 14px;
                margin-top: 10px;
            }
        }
    }
}
</style>